<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>

        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>

<script>
const requestConfig = require('../bin/config')
process.appDomain = requestConfig.appDomain
process.staticDomain = requestConfig.staticDomain

global.apiDomain = ''

export default {
    name: 'App',
    metaInfo: {
        title: 'All Sepakbola'
    }
}
</script>

<style></style>



// WEBPACK FOOTER //
// App.vue?ba3b9d5a